// 私人印刷机相关路由
export default {
  routes: [
    // 私人印刷机首页 pv，uv几乎为0，页面已下线
    {
      path: '/(\\s*)cashprinter(\\d*)/(\\s*)index(\\d*)',
      name: 'CashPrinterHome',
      meta: {
        desc: '私人印刷机'
      },
      component: () =>
        import(/* webpackChunkName: "CashPrinterHome" */ '../views/cashprinter/index/index.vue')
    }
  ]
}
